export const baseUrl = '/biohazardous-manifests'
